import { ChevronRight } from 'lucide-react';
import Link from 'next/link';
import { GameCard } from '@/components/shared/m-game-card';

export const MisteryChoice = () => {
  return (
    <div className="py-2">
      <div className="flex justify-between">
        <h4 className="font-bold text-sm text-[#FFA035] px-4 pb-2">
          Mistery Choice
        </h4>
        <Link
          href="/pages/m-more-games"
          className="text-[10px] text-white flex items-center gap-1 px-4 cursor-pointer hover:opacity-80 active:opacity-70"
        >
          more games <ChevronRight className="size-3" />
        </Link>
      </div>
      <div className="p-2 grid grid-cols-3 gap-2 bg-[#801C80]/40 rounded-lg mx-2">
        <GameCard
          title="Extreme Vegas"
          totalViews={1384}
          imageUrl="/vegas-hot-games.png"
        />
        <GameCard
          title="Extreme Vegas"
          totalViews={1384}
          imageUrl="/vegas-hot-games.png"
        />
        <GameCard
          title="Extreme Vegas"
          totalViews={1384}
          imageUrl="/vegas-hot-games.png"
        />
        <GameCard
          title="Extreme Vegas"
          totalViews={1384}
          imageUrl="/vegas-hot-games.png"
        />
        <GameCard
          title="Extreme Vegas"
          totalViews={1384}
          imageUrl="/vegas-hot-games.png"
          liked={true}
        />
        <GameCard
          title="Extreme Vegas"
          totalViews={1384}
          imageUrl="/vegas-hot-games.png"
          liked={true}
        />
      </div>
    </div>
  );
};
